<script setup>

import {ref} from 'vue'

const tooltipElement = ref(null);
const subjectContainer = ref(null);
const timer = ref(null)

const props = defineProps({
  icon: {type: Boolean, default: true},
  width: {type: String, default: ''},
  maxWidth: {type: String, default: ''}
})

const mouseOver = (e) => {

  timer.value = setTimeout(function() {

    if(tooltipElement.value &&  subjectContainer.value) {
      tooltipElement.value.style.cssText = "display: block;"

      let subjectBottomPosition = subjectContainer.value.getBoundingClientRect().bottom + 3
      let subjectLeftPosition = subjectContainer.value.getBoundingClientRect().left -2

      tooltipElement.value.style.cssText = `display: block; width: ${props.width + 'px'};
     top: ${subjectBottomPosition + 'px'}; left: ${subjectLeftPosition + 'px'};`

    }

  }, 700)

}

const mouseOut = () => {

  clearTimeout(timer.value)
  tooltipElement.value.style.cssText = "display: none;"
}
</script>

<template>
  <span id="Vue-3-component-static-tooltip" class="tooltip-wrapper">
    <span @mouseover="mouseOver" @mouseout="mouseOut" ref="subjectContainer"><slot></slot></span>
    <span class="tooltip-content" ref="tooltipElement"><span v-if="icon" class="tooltip-icon">&#128712 </span>
        <slot name="content"></slot>
    </span>
  </span>
</template>

<style scoped>

.tooltip-wrapper {
  cursor: default;
  user-select: none;
  /*line-height: 2.0;*/
  word-break: break-word;
  /*width: max-content;*/
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tooltip-content {
  padding: 10px;
  box-shadow: 0px 1px 4px 0px #888888;
  line-height: normal;
  font-weight: normal;
  white-space: normal;
}

.tooltip-wrapper .tooltip-content {
  position: fixed;
  border-radius: 4px;
  height: auto;
  font-size: 12px;
  color: #000000;
  background-color: #ffffff;
  /*background-image: linear-gradient(0deg, #0c2137, #395383);*/
  z-index: 100000;
  display: none;
}

.tooltip-icon {
  color: var(--info-icon-color);
}

</style>
